var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1844_18335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16797 4.29004H3.33464C2.89261 4.29004 2.46868 4.46563 2.15612 4.77819C1.84356 5.09075 1.66797 5.51468 1.66797 5.95671V17.6234C1.66797 18.0654 1.84356 18.4893 2.15612 18.8019C2.46868 19.1144 2.89261 19.29 3.33464 19.29H15.0013C15.4433 19.29 15.8673 19.1144 16.1798 18.8019C16.4924 18.4893 16.668 18.0654 16.668 17.6234V11.79",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.418 3.04023C15.7495 2.70871 16.1991 2.52246 16.668 2.52246C17.1368 2.52246 17.5864 2.70871 17.918 3.04023C18.2495 3.37175 18.4357 3.82139 18.4357 4.29023C18.4357 4.75907 18.2495 5.20871 17.918 5.54023L10.0013 13.4569L6.66797 14.2902L7.5013 10.9569L15.418 3.04023Z",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1844_18335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.956543)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditW);
export default __webpack_public_path__ + "static/media/edit_w.077b8420fe30c7949aededec9fddfcd1.svg";
export { ForwardRef as ReactComponent };